import { tsrClient } from '@/libs/ts-rest/ts-client';
import { createListReviewsQueryOptions } from '@/modules/products/react-query';
import { WebContractReviewQueryParams } from '@packages/contracts';

export const useListReviewsQuery = (queryParams: WebContractReviewQueryParams) => {
	const queryOptions = createListReviewsQueryOptions(queryParams);
	const reviewListQueryResult = tsrClient.web.reviews.list.useQuery(queryOptions);

	return reviewListQueryResult;
};
